import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { FreemiumJdData } from '../freemiumParams';
import { interval } from 'rxjs';
import { WebbtreeJdSearchFilterModalComponent } from '../webbtree-jd-search-filter-modal/webbtree-jd-search-filter-modal.component';
import { FreemiumAPIService } from '../freemium-api.service';

@Component({
    selector: 'app-gen-ai-loader',
    templateUrl: './gen-ai-loader.component.html',
    styleUrls: ['./gen-ai-loader.component.scss'],
    standalone: false
})
export class GenAiLoaderComponent implements OnInit {

  @Input() description = "";
  private jdResponse: FreemiumJdData = null;

  constructor(private activeModal: NgbActiveModal, private searchtoolbox: SearchtoolboxService, private modalService: NgbModal, private freemiumApiService: FreemiumAPIService) { }

  ngOnInit() { this.increaseProgress(); }

  progressValue: number = 0;

  increaseProgress() {
    const interval$ = interval(500); // Change interval duration as needed
    const subscription = interval$.subscribe(() => {
      this.progressValue += 10;
      if (this.progressValue >= 80) {
        this.progressValue = this.jdResponse ? 100 : 99;
      }
      if (this.progressValue === 100) {
        subscription.unsubscribe();
        setTimeout(() => {this.activeModal.close(this.jdResponse);
      }, 500);

      }
    });

    this.description &&this.freemiumApiService.freemiumParseJobDescription(this.description).subscribe((res: FreemiumJdData) => {
      this.jdResponse = res;
    });
  }

}
